import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  ViewChild,
} from "@angular/core";
import { Observable, Subject } from "rxjs";
import { FormControl } from "@angular/forms";
import { startWith, map, takeUntil } from "rxjs/operators";
import { AuthService } from "../../../core/services/auth.service";
import { RequireMatch } from "../../../core/helpers/requiredMatch";
import { MultiselectAutocompleteComponent } from "../multiselect-autocomplete/multiselect-autocomplete.component";

@Component({
  standalone: false,
  selector: "app-dispatch-zones",
  templateUrl: "./dispatch-zones.component.html",
  styleUrls: ["./dispatch-zones.component.sass"],
})
export class DispatchZonesComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild(MultiselectAutocompleteComponent)
  childMultiselectAutocomplete: MultiselectAutocompleteComponent;
  @Output() onChangeZone = new EventEmitter<any>();
  @Input() zones = [];
  @Input() myHint: string;
  @Input() placeholder: string = "Zona de despacho";
  @Input() disabledMultiselect = false;
  listZonesAutocomplet: Observable<any[]>;
  zoneCode: FormControl = new FormControl();
  private onDestroy$: Subject<void> = new Subject<void>();
  companyCode;
  zoneCodesSelected: any[] = [];
  constructor(private authService: AuthService) {
    this.zoneCode.setValidators(RequireMatch);
    this.companyCode = this.authService.getUser().entity.company.code;
  }

  ngOnInit() {}

  ngOnChanges() {}

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  setZoneList(zoneList: any[]) {
    this.childMultiselectAutocomplete.setValues(zoneList);
  }

  resetZonesSelected() {
    this.childMultiselectAutocomplete.resetForm();
  }

  emitChangeZone() {
    this.onChangeZone.emit(this.zoneCode.value);
  }

  setZones(zones: any[]) {
    this.zones = zones;
  }

  emitElementsListed(event) {
    if (event && this.zoneCodesSelected && this.zoneCodesSelected.length > 0) {
      this.setZonesSelected();
    }
  }

  setZone(zoneCodes: any) {
    this.zoneCodesSelected = zoneCodes;
  }

  setZonesSelected() {
    const zonesSelected = [];
    this.zoneCodesSelected.map((zoneCode) => {
      const zoneSelected = this.findZone(zoneCode);
      if (zoneSelected) {
        zonesSelected.push(zoneSelected);
      }
    });
    if (zonesSelected && zonesSelected.length > 0) {
      this.zoneCode.setValue(zonesSelected);
      this.setZoneList(zonesSelected);
      this.emitChangeZone();
    }
  }

findZone(zoneCode: string): string | null {
  const zone = this.zones.find(zone => zone.zoneId === zoneCode);
  return zone ? zone.zoneId : null;
}

  emitZones(event) {
    if (event && event.data) {
      this.zoneCode.setValue(event.data);
      this.emitChangeZone();
    }
  }
}
